const STORAGE_KEY = 'whistle_successful_lead';
const TTL_MS = 30 * 60 * 1000;

function splitName(fullName) {
  const trimmed = (fullName || '').trim();
  if (!trimmed) return { firstName: '', lastName: '' };
  const parts = trimmed.split(/\s+/);
  return {
    firstName: parts[0],
    lastName: parts.length > 1 ? parts.slice(1).join(' ') : '',
  };
}

function normalizePhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');

  if (digits.length === 10) {
    return `+91${digits}`;
  }

  if (digits.length === 12 && digits.startsWith('91')) {
    return `+${digits}`;
  }

  return digits ? `+91${digits.slice(-10)}` : '';
}

export function clearSuccessfulLead() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // sessionStorage may be unavailable in private mode
  }
}

export function saveSuccessfulLead({ name, phone, email, city } = {}) {
  const normalizedPhone = normalizePhone(phone);
  const { firstName, lastName } = splitName(name);

  if (!firstName || !normalizedPhone) return;

  const payload = {
    name: (name || '').trim(),
    phone: normalizedPhone,
    firstName,
    lastName,
    email: (email || '').trim() || undefined,
    city: (city || '').trim() || undefined,
    savedAt: Date.now(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore
  }
}

export function consumeSuccessfulLead() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    sessionStorage.removeItem(STORAGE_KEY);
    if (!raw) return null;

    const lead = JSON.parse(raw);
    if (!lead?.savedAt || Date.now() - lead.savedAt > TTL_MS) return null;
    if (!lead.firstName || !lead.phone) return null;

    return lead;
  } catch {
    return null;
  }
}

export function pushLeadConversionEvent(lead) {
  if (typeof window === 'undefined' || !lead) return;

  const enhancedConversionData = {
    phone_number: lead.phone,
    first_name: lead.firstName,
  };

  if (lead.lastName) enhancedConversionData.last_name = lead.lastName;
  if (lead.email) enhancedConversionData.email = lead.email;
  if (lead.city) enhancedConversionData.city = lead.city;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'Lead',
    enhanced_conversion_data: enhancedConversionData,
  });
}
